<template>
	<canvas :id="uniqueCssId" :height="height" :width="width"></canvas>
</template>

<script>
import Chart from 'chart.js';
// DOCS: http://www.chartjs.org/docs/latest/
export default {
	props: ['properties', 'height', 'width'],
	data () {
		return {
			x: 0,
			y: 0
		};
	},
	mounted () {
		this.renderChart(this.properties);
	},
	created () {
		this.chart = null;
		this.canvasContext = null;
	},
	watch: {
		properties () {
			this.renderChart(this.properties);
		}
	},
	destroyed () {
		this.canvasContext = null;
		if (this.chart !== null) this.chart.destroy();
		this.chart = null;
	},
	computed: {
		uniqueCssId () {
			return 'chart-canvas-' + Math.random().toString(36).substring(7);
		},
		tooltipStyle () {
			return `top: ${this.y}px; left: ${this.x}px`;
		}
	},
	methods: {
		renderChart (properties) {

			this.canvasContext = document.getElementById(this.uniqueCssId);

			const vueInstance = this;

			if (this.chart !== null) this.chart.destroy();

			this.chart = new Chart(this.canvasContext, properties);
		},
		getDataChart (value) {
			if (this.tooltipInfo > 0) {
				return 'up';
			}
			if (this.tooltipInfo < 0) {
				return 'down';
			}
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/ui/Chart.vue